import React, { Component } from 'react'; //different
import './App.css';
import Footer from './footer';
import jwt_decode from "jwt-decode";
import Swal from 'sweetalert2'
import instance from "./axios-instance";
import { NumericFormat } from 'react-number-format';
import Systems from "./SystemFunction";
import moment from 'moment';
import md5 from 'md5';
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            categorylist: [],
            rewardlist: [],
            activePage: 1,
            pagecount: 1,
            products_page_count: 1,
            isActive: false,
            activeTab: 1,
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            loading: true, // Indicates in progress state of login form
            tblprofile: [],
            userid: null,
            linkaff: "",
            totalRow:0,
            stats: { todaySignups: 0, thisMonthSignups: 0, lastMonthSignups: 0, totalSignups: 0, percentChange: "0.00" },
            timeRange: "today",
            reports: {},
            afficiatetoday: [],
            point: 0,
            useradvice: [],
            currentPage:1,
            balance: 0,
            loginstate: null,
            firstname: null,
            lastname: null,
            alert: null,
            modalOpen: false,
            handleClose: false,
            proderedeemlist: [],
            token: window.localStorage.getItem("token"),
            type: "",
            username: "",
            tabselect: 1,
            amount: "",
            remark: "",
            mainacc: "",
            rankpic: "1.jpeg",
            rankname: null,
            rankob: null,
            rankpoint: 0,
            name: "",
            password: "",
            left: false,
        }
    }
    logout = (e) => {

        // window.location.href = '/logout';

    }
    waitnotify = async () => {
        setTimeout(() => { console.log('World!') }, 5000)
    }
    async opencliaminvite(evt, cityName) {
        console.log(cityName);

        var token = localStorage.getItem('auth_token');
        if (token) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            await instance.post("/api/v1/cliaminvite", {
                userid: Username,
                System: Systems,
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                if (res.data.status === 200) {
                    var decoded = jwt_decode(token);
                    var Username = decoded.message.playerid;
                    this.rechecklogin(Username, token);
                    await Swal.fire({
                        title: 'Success!',
                        text: 'ເຮັດລາຍການຮັບເງິນຮຽບຮ້ອຍ',
                        icon: 'success',
                        confirmButtonText: 'ຕົກລົງ'
                    })

                }
                else if (res.data.status === 201) {
                    await Swal.fire({
                        title: 'error!',
                        text: 'ບໍ່ສາມາດເຮັດລາຍການໄດ້ ບໍ່ມີຍອດເງິນ',
                        icon: 'error',
                        confirmButtonText: 'ຕົກລົງ'
                    })
                    return false;
                }
                else if (res.data.status === 202) {
                    await Swal.fire({
                        title: 'error!',
                        text: 'ບໍ່ສາມາດເຮັດລາຍການໄດ້',
                        icon: 'error',
                        confirmButtonText: 'ຕົກລົງ'
                    })
                    return false;
                }

            }).catch(async (err) => {
                // console.log(err);
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await Swal.fire({
                        title: 'Warning!',
                        text: 'Session ຂອງທ່ານໝົດອາຍຸ ກະລຸນາ login ເຂົ້າສູ່ລະບົບອີກຄັ້ງ',
                        icon: 'warning',
                        confirmButtonText: 'ຕົກລົງ'
                    })
                    window.location.href = '/';
                }
            });
        }
        else {
            await Swal.fire({
                title: 'error!',
                text: 'ກະລຸນາເຂົ້າສູ່ລະບົບ',
                icon: 'error',
                confirmButtonText: 'ຕົກລົງ'
            })
            return false;
        }
    }
    checktab(e, index) {
        //console.log(index == 2 &&  this.state.qrcode != null);

        this.setState({
            tabselect: index,
        });


    }
    notify = async (mode, msg) => {
        console.log(mode, msg);
        if (mode == "success") {
            await toast.success(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "warning") {
            await toast.warning(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "error") {
            await toast.error(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "info") {
            await toast.info(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        await this.waitnotify();
    }
    copyCode = async (text) => {
        // Now, we can write to the clipboard in Safari
        await navigator.clipboard
            .writeText(text)
            .then(() => {
                this.notify("warning", 'CopyCode!!!');
            })
            .catch((err) => {
                // console.log(err.message);
            });



    };
    async componentDidMount() {
        await instance.post("/api/v1/mainsetting", {
            System: Systems,
        }).then((res) => {
            if (res.data.status === 200) {
                const datas = res.data.message;
                this.setState({
                    linelink: datas[1].value,
                });
            }
            else {
                // this.CheckThisGoalError();
            }
        });
        var userAgent = navigator.userAgent.toLowerCase()
        try {
            var token = localStorage.getItem('auth_token');
            //  //////console.log(token);
            if (token != null) {
                var decoded = jwt_decode(token);
                var Username = decoded.message.playerid;
                await this.rechecklogin(Username, token);
                this.setState({
                    userid: decoded.message.playerid,
                    username: decoded.message.playerid,
                    firstname: decoded.message.firstname,
                    lastname: decoded.message.lastname,
                    loginstate: true,
                });
                this.checkuseradvice(decoded.message.playerid);

            }
            else {
                this.setState({
                    loginstate: false,
                });
            }

        }
        catch (error) {
            //////console.log();
        }

    }
    openAccout(evt, cityName) {
        var i, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName("x-menu-account-list-sidebar");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].className += " -open";
        }
    }
    async checkuseradvice(username) {
        instance.post("/api/v1/checkuseradvice", {
            User_id: username,
            page: 1,
            System: Systems,
        }).then((res) => {
            // รับทั้ง 200 (มีสมาชิกแนะนำ) และ 201 (ยังไม่มีสมาชิก แต่ backend ส่ง stats = 0 มาด้วย)
            if ((res.data.status === 200 || res.data.status === 201) && res.data.message) {
                console.log("statsstatsstatsstats", res.data.message);
                const msg = res.data.message;
                this.setState({
                    stats: msg.stats || {},
                    reports: msg.reports || {},
                    afficiatetoday: Array.isArray(msg.userafftoday) ? msg.userafftoday : [],
                    useradvice: Array.isArray(msg.useradvicelist) ? msg.useradvicelist : []
                });
            }
            else {
                // console.log(res.data);
                // this.CheckThisGoalError();
            }
        });
    }
    cancelredeempromotion = async (e, index) => {
        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            Swal.fire({
                icon: 'warning',
                title: 'ທ່ານຕ້ອງການຍົກເລີກການໃຊ້ໂປຣ ແມ່ນ ຫຼື ບໍ່?',
                showCancelButton: true,
                confirmButtonText: 'Save',
            }).then(async (result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    await instance.post("/api/v1/usercancelpromotion", {
                        User_id: Username,
                        System: Systems,
                        no: index.no,
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    }).then(async (res) => {
                        if (res.data.status === 200) {
                            this.checkpro(null, 999);
                            Swal.fire('ດຳເນີນການຮຽບຮ້ອຍ', '', 'success')
                        }
                        else {
                            Swal.fire('ບໍ່ສາມາດດຳເນີນການໄດ້ ກະລຸນາລໍຖ້າ', '', 'error')
                        }
                    });

                }
            })
        }

    }

    openAccoutcan(evt, cityName) {
        var i, tabcontent, tablinks;
        tabcontent = document.getElementsByClassName("x-menu-account-list-sidebar");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].className = "x-menu-account-list-sidebar";
        }
    }

    async rechecklogin(Username, token) {

        try {
            // console.log(4);
            const search = window.location.href;
            const paramx = new URLSearchParams(search);
            // const space = search.split("/")
            const space = window.location.host
            var userhash = md5(Username);
            //  const linkaff = "https://pgline88.com/?register=" + userhash;
            const linkaff = "https://" + space + "/register?reg=" + userhash;
            instance.post("/api/v1/checkpoint", {
                userid: Username,
                System: Systems,
                Function: 'rechecklogin-navbar.js'
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                //  console.log(res.data);
                if (res.data.status === 200) {
                    localStorage.setItem('auth_token', res.data.token)
                    this.setState({
                        rankpic: res.data.tblrank.image,
                        rankname: res.data.tblrank.name,
                        linkaff: linkaff,
                        rankob: res.data.tblrank,
                        rankpoint: res.data.rankpoint,
                        accnumber: res.data.message.accnumber,
                        userid: res.data.message.member_id,
                        tblprofile: res.data.message,
                        username: res.data.message.playerid,
                        fname: res.data.message.firstname,
                        point: res.data.message.Point,
                        balance: res.data.databalance,
                        loginstate: true,
                    });
                }
                else if (res.data.status === 401) {
                    localStorage.clear();
                    await Swal.fire({
                        title: 'Warning!',
                        text: 'Session ຂອງທ່ານໝົດອາຍຸ ກະລຸນາ login ເຂົ້າສູ່ລະບົບອີກຄັ້ງ',
                        icon: 'warning',
                        confirmButtonText: 'ຕົກລົງ'
                    })
                    window.location.href = '/';
                }

            }).catch(async (err) => {
                console.log(err)
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await Swal.fire({
                        title: 'Warning!',
                        text: 'Session ຂອງທ່ານໝົດອາຍຸ ກະລຸນາ login ເຂົ້າສູ່ລະບົບອີກຄັ້ງ',
                        icon: 'warning',
                        confirmButtonText: 'ຕົກລົງ'
                    })
                    window.location.href = '/';
                }
            });
        }
        catch (ex) {
            //////console.log(ex);
        }

    }
    checkpro = async (e, proid) => {
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        await instance.post("/api/v1/checkpromotion", {
            userid: Username,
            System: Systems,
            Proid: proid,
        }, {
            headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
            if (res.data.status === 200) {
                //console.log(res.data)
                // console.log(res.data.message.tblpromotionredeems)
                if (res.data.type === 0) {
                    this.setState({
                        prodetail: res.data.message.tblpromotions,
                    });
                }
                else if (res.data.type === 1) {
                    this.setState({
                        proderedeemlist: res.data.message.tblpromotionredeems,
                    });

                }

            }
            else if (res.data.status === 201) {
                await Swal.fire({
                    title: 'error!',
                    text: 'ທ່ານບໍ່ເຂົ້າເງື່ອນໄຂໂປຣໂມຊັ່ນນີ້',
                    icon: 'error',
                    confirmButtonText: 'ຕົກລົງ'
                })
                return false;
            }
            else if (res.data.status === 202) {
                await Swal.fire({
                    title: 'error!',
                    text: 'ທ່ານໃຊ້ໂປຣໂມຊັ່ນຄ້າງໄວ້ ສາມາດເຕີມເງິນໄດ້ເລີຍ',
                    icon: 'error',
                    confirmButtonText: 'ຕົກລົງ'
                })
                return false;
            }

        }).catch(async (err) => {
            // console.log(err);
            if (err.response.status === 401 || err.response.status === 403) {
                localStorage.clear();
                await Swal.fire({
                    title: 'Warning!',
                    text: 'Session ຂອງທ່ານໝົດອາຍຸ ກະລຸນາ login ເຂົ້າສູ່ລະບົບອີກຄັ້ງ',
                    icon: 'warning',
                    confirmButtonText: 'ຕົກລົງ'
                })
                window.location.href = '/';
            }
        });
    }


    validateLogout = (e) => {
        localStorage.removeItem('auth_token', '')
        this.setState({
            userid: null,
            username: null,
            password: null,
            firstname: null,
            lastname: null,
            point: null,
            loginstate: false,
        });
    }
    async recheccredit(evt) {

        evt.currentTarget.className += " fa-spin";
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        //  this.rechecklogin(Username, token);
        this.setState({
            userid: decoded.message.playerid,
            username: decoded.message.playerid,
            firstname: decoded.message.firstname,
            lastname: decoded.message.lastname,
            loginstate: true,
        });
        try {
            //  console.log(5);
            await instance.post("/api/v1/checkpoint", {
                userid: Username,
                System: Systems,
                Function: 'recheccredit-navbar.js'
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                //console.log(res.data);
                if (res.data.status === 200) {
                    localStorage.setItem('auth_token', res.data.token)
                    this.setState({
                        accnumber: res.data.message.accnumber,
                        userid: res.data.message.member_id,
                        username: res.data.message.playerid,
                        fname: res.data.message.firstname,
                        point: res.data.message.Point,
                        balance: res.data.databalance,
                        loginstate: true,
                    });
                    var i, tablinks;
                    tablinks = document.getElementsByClassName("-btn-balance");
                    for (i = 0; i < tablinks.length; i++) {
                        tablinks[i].className = tablinks[i].className.replace(" fa-spin", "");
                    }
                }
                else if (res.data.status === 401) {
                    localStorage.clear();
                    //   console.log(res.data);
                    await Swal.fire({
                        title: 'Warning!',
                        text: 'Session ຂອງທ່ານໝົດອາຍຸ ກະລຸນາ login ເຂົ້າສູ່ລະບົບອີກຄັ້ງ',
                        icon: 'warning',
                        confirmButtonText: 'ຕົກລົງ'
                    })
                    window.location.href = '/';
                }

            }).catch(async (err) => {
                //    console.log(err);
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await Swal.fire({
                        title: 'Warning!',
                        text: 'Session ຂອງທ່ານໝົດອາຍຸ ກະລຸນາ login ເຂົ້າສູ່ລະບົບອີກຄັ້ງ',
                        icon: 'warning',
                        confirmButtonText: 'ຕົກລົງ'
                    })
                    window.location.href = '/';
                }
            });
        }
        catch (ex) {
            //////console.log(ex);
        }
    }
    logout = (e) => {
        // e.preventDefault();
        let errors = this.validateLogout();
        if (errors === true) {
            // alert("You are successfully signed in...");
            window.location.reload()
        } else {

            this.setState({
                errors: errors,
                formSubmitted: true
            });
            window.location.reload()
        }
    }
    handlePageChange =async (newPage) => {
        console.log("newPage",newPage);
        if (newPage > 0 && newPage <= this.state.totalPages) {           
            this.setState({ currentPage: newPage },await this.handleTimeRangeChange(this.state.timeRange));
        }
    };
    handleTimeRangeChange = async (range) => {
        var token = localStorage.getItem('auth_token');
        this.setState({
            timeRange: range,
        });
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            instance.post("/api/v1/checkuseradvice", {
                User_id: Username,
                page: this.state.currentPage,
                timeRange: range,
                System: Systems,
            }).then((res) => {
                if ((res.data.status === 200 || res.data.status === 201) && res.data.message) {
                    //console.log("statsstatsstatsstats", res.data.userafftoday);
                    this.setState({
                        timeRange: range,
                        afficiatetoday: Array.isArray(res.data.message.userafftoday) ? res.data.message.userafftoday : [],
                        totalPages: res.data.message.pagecount,
                        totalRow: res.data.message.products_page_count,
                    });
                }
                else {
                    // console.log(res.data);
                    // this.CheckThisGoalError();
                }
            });
        }
    }
    render() {
        const timeRanges = [
            { key: "today", label: "ມື້ນີ້" },
            { key: "last7days", label: "7 ວັນທີ່ແລ້ວ" },
            { key: "lastMonth", label: "ເດືອນທີ່ແລ້ວ" },
            { key: "all", label: "ທັງໝົດ" },
        ];

        const { afficiatetoday,currentPage,totalRow, loginstate, userid, username, point, firstname, lastname, balance, proderedeemlist, linkaff, tblprofile } = this.state
        const offset = (currentPage - 1) * 20; // หาຈຳນວນรายการที่ข้ามไปก่อนหน้า

       // console.log("afficiatetoday",  (currentPage - 1) * 20)
        return (
            <>

                <div>
                    <br />
                    <br />
                    <br />
                </div>
                <section className="-contact-wrapper row m-0">
                    <div className="padding-router-view">
                        <div className="container p-0 x-margin-top-v3">
                            <div className="row m-0 border-shadow-title">
                                <div className="col-12 p-0 col-sm-7 col-md-7 col-lg-7 col-xl-7 mx-auto my-auto text-white-v1">
                                    <div className="text-center bg-title-web">
                                        <div>
                                            <div className="text-title text-white-v1 text-center">
                                                <div className="d-flex justify-content-between">
                                                    <div className="text-white-v1-deposit">
                                                        <a role="button"
                                                            href='/'
                                                        >
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width={25}
                                                                height={25}
                                                                fill="currentColor"
                                                                className="bi bi-arrow-left-circle text-color-back"
                                                                viewBox="0 0 16 16"
                                                            >
                                                                <path
                                                                    fillRule="evenodd"
                                                                    d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                                                                />
                                                            </svg>
                                                        </a>
                                                    </div>
                                                    <div className="text-white-v1-deposit">
                                                        <h5>ແນະນຳໝູ່</h5>
                                                    </div>
                                                    <div>{/**/}</div>
                                                </div>
                                                <hr className="mt-0" />
                                            </div>
                                        </div>
                                        <div>
                                            <div
                                                className="d-flex justify-content-between p-1 text-white-v1 bg-refer-title"
                                                style={{ width: "100%", overflowX: "scroll" }}
                                            >
                                                {/* this.state.tabselect == 1 ? "" : "none" */}
                                                <div className="active-tap-hover"  >
                                                    <div
                                                        onClick={(e) => {
                                                            this.checktab(e, 1)
                                                        }}
                                                        role="button"
                                                        className={this.state.tabselect == 1 ? "text-white-v1 p-1 rounded-pill w-width-tap  active-refer" : "text-white-v1 p-1 rounded-pill w-width-tap"}
                                                    >
                                                        <div data-v-ab1d19ba="" className="auction-width">
                                                            <div
                                                                data-v-ab1d19ba=""
                                                                className="auction__body-menu auction__body--border-radius"
                                                            >
                                                                <div
                                                                    data-v-ab1d19ba=""
                                                                    className="tab text-white-v1"
                                                                >
                                                                    <div
                                                                        data-v-00ef951c=""
                                                                        className="auction-pool-menu text-center"
                                                                    >
                                                                        <span className="text-size-menu-casino">
                                                                            <b>ພາບລວມ</b>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="active-tap-hover">
                                                    <div
                                                        onClick={(e) => {
                                                            this.checktab(e, 2)
                                                        }}
                                                        role="button"
                                                        className={this.state.tabselect == 2 ? "text-white-v1 p-1 rounded-pill w-width-tap  active-refer" : "text-white-v1 p-1 rounded-pill w-width-tap"}
                                                    >
                                                        <div data-v-ab1d19ba="" className="auction-width">
                                                            <div
                                                                data-v-ab1d19ba=""
                                                                className="auction__body-menu auction__body--border-radius"
                                                            >
                                                                <div
                                                                    data-v-ab1d19ba=""
                                                                    className="tab text-white-v1"
                                                                >
                                                                    <div
                                                                        data-v-00ef951c=""
                                                                        className="auction-pool-menu text-center"
                                                                    >
                                                                        <span className="text-size-menu-casino">
                                                                            <b>ສະມາຊິກ</b>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="active-tap-hover">
                                                    <div
                                                        onClick={(e) => {
                                                            this.checktab(e, 3)
                                                        }}
                                                        role="button"
                                                        className={this.state.tabselect == 3 ? "text-white-v1 p-1 rounded-pill w-width-tap  active-refer" : "text-white-v1 p-1 rounded-pill w-width-tap"}
                                                    >
                                                        <div data-v-ab1d19ba="" className="auction-width">
                                                            <div
                                                                data-v-ab1d19ba=""
                                                                className="auction__body-menu auction__body--border-radius"
                                                            >
                                                                <div
                                                                    data-v-ab1d19ba=""
                                                                    className="tab text-white-v1"
                                                                >
                                                                    <div
                                                                        data-v-00ef951c=""
                                                                        className="auction-pool-menu text-center"
                                                                    >
                                                                        <span className="text-size-menu-casino">
                                                                            <b>ສະຫຼຸບລາຍໄດ້</b>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="active-tap-hover">
                                                    <div
                                                        onClick={(e) => {
                                                            this.checktab(e, 4)
                                                        }}
                                                        role="button"
                                                        className={this.state.tabselect == 4 ? "text-white-v1 p-1 rounded-pill w-width-tap  active-refer" : "text-white-v1 p-1 rounded-pill w-width-tap"}
                                                    >
                                                        <div data-v-ab1d19ba="" className="auction-width">
                                                            <div
                                                                data-v-ab1d19ba=""
                                                                className="auction__body-menu auction__body--border-radius"
                                                            >
                                                                <div
                                                                    data-v-ab1d19ba=""
                                                                    className="tab text-white-v1"
                                                                >
                                                                    <div
                                                                        data-v-00ef951c=""
                                                                        className="auction-pool-menu text-center"
                                                                    >
                                                                        <span className="text-size-menu-casino">
                                                                            <b>ເຄືອຂ່າຍ</b>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mb-5 mt-2" style={{ display: this.state.tabselect == 1 ? "" : "none" }}>
                                        <div className="p-2 bg-profile-box-overview">
                                            <div className="   mt-2">

                                                <div className="bg-profile-box-overview p-2">
                                                    <div className="d-flex justify-content-between row m-0 align-items-center">
                                                        <div className="col-12 col-md-12 p-0">
                                                            <div className="d-flex justify-content-between elementor-element-play-overview text-center bg-profile-credit-bl p-2">
                                                                <div className="align-self-center">
                                                                    <div className="p-1 text-left">
                                                                        <div>
                                                                            <h3 className="m-0">
                                                                                <b className="p-1"> {this.state.reports && this.state.reports.lastMonth
                                                                                    ? this.state.reports.lastMonth.totalAmount
                                                                                    : 0}</b>
                                                                            </h3>
                                                                        </div>
                                                                        <small>ລາຍໄດ້ຈາກເຄືອຂ່າຍ ທັງໝົດ</small>
                                                                    </div>
                                                                </div>
                                                                <div className="align-self-center text-right">
                                                                    <div>
                                                                        <span className="badge text-bg-dark">
                                                                            {this.state.reports.percentageChange}%
                                                                        </span>
                                                                    </div>
                                                                    <div>
                                                                        <span className="font-play-text">
                                                                            ຈາກເດືອນທີ່ແລ້ວ
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="mt-2   ">
                                                    <div className="mt-2 mb-2">
                                                        <img
                                                            className="icon-profile-title-left"
                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/81deef6a-eb5d-4bf2-221c-3b85586ca700/public"
                                                            alt=""
                                                        />
                                                        <small className="pt-2 pb-2">
                                                            <b>&nbsp; ລິ້ງເຊີນຊວນ</b>
                                                        </small>
                                                    </div>
                                                    <div className="bg-color-financial-my-bank bg-profile-box-overview">
                                                        <div className="d-flex justify-content-between pt-3 pb-3">
                                                            <div>
                                                                <small>ສຳເນົາ</small>
                                                            </div>
                                                            <div>
                                                                <small className="font-play-text">
                                                                    <b>
                                                                        <small id="copy-ShareLink">
                                                                            {linkaff}
                                                                        </small>
                                                                        {/* <a href={() => false} style={{ cursor: "pointer" }}
                                                                                    onClick={() => navigator.clipboard.writeText(linkaff)}>
                                                                              

                                                                                </a> */}
                                                                        <a href={() => false} style={{ cursor: "pointer" }} onClick={() => this.copyCode(linkaff)} className="-copy-wrapper js-copy-to-clipboard" data-container="shareAccountProfileBankInfo" data-message="ສຳເນົາແລ້ວ!" >
                                                                            <img
                                                                                role="button"
                                                                                className="icon-profile-title-left"
                                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/270b7b9f-b130-414c-b2a8-dfe9ecb9cc00/public"
                                                                                alt=""
                                                                            />
                                                                        </a>
                                                                    </b>
                                                                </small>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="pt-2">
                                                    <div className="row m-0">
                                                        <div className="col-12 col-md-12 p-1">
                                                            <div className="d-flex justify-content-between financial-button">
                                                                <div
                                                                    role="button"
                                                                    className="align-self-center p-1 credit-bl-text"
                                                                >
                                                                    <div role="button" className="financial-button-r">
                                                                        <div className="d-flex justify-content-start">
                                                                            <div className="align-self-center">
                                                                                <img
                                                                                    className="logo-profile-user-w p-1"
                                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/48a22d9a-8abe-477f-0f40-57204ce17700/public"
                                                                                    alt=""
                                                                                />
                                                                            </div>
                                                                            <div className="align-self-center">
                                                                                <div className="username-profile">
                                                                                    <small>ລາຍໄດ້ທີ່ຖອນໄດ້</small>
                                                                                </div>
                                                                                <div className="username-profile">
                                                                                    <small>
                                                                                        <b className="font-aff-wid">{(tblprofile.AffiliateCash && tblprofile.AffiliateCash > 0)
                                                                                            ? tblprofile.AffiliateCash
                                                                                            : 0}</b>
                                                                                    </small>
                                                                                    <a

                                                                                        role="button"
                                                                                        className="text-white-v1-credit-balance p-1"
                                                                                        id="icon-refresh-credit"
                                                                                    >
                                                                                        <span>
                                                                                            <b>
                                                                                                <svg
                                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                                    width={18}
                                                                                                    height={18}
                                                                                                    fill="currentColor"
                                                                                                    className="text-white-v1 bi bi-arrow-clockwise"
                                                                                                    viewBox="0 0 16 16"
                                                                                                >
                                                                                                    <path
                                                                                                        fillRule="evenodd"
                                                                                                        d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
                                                                                                    />
                                                                                                    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                                                                                                </svg>
                                                                                            </b>
                                                                                        </span>
                                                                                    </a>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="align-self-center">
                                                                    <a role="button"
                                                                        onClick={(e) => {
                                                                            this.opencliaminvite(e, 'bonusrankaccount')
                                                                        }}>
                                                                        <div className="bg-text-highlight pd-bl-aff">
                                                                            <div
                                                                                disabled="false"
                                                                                role="button"
                                                                                className="btn -submit js-submit-accept-term mt-0 w-100 p-2"
                                                                            >
                                                                                <img
                                                                                    className="wid-button p-1"
                                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/de26db72-10a7-4369-5e7e-dd07d4568300/public"
                                                                                    alt=""
                                                                                />
                                                                                <span>ຖອນລາຍໄດ້</span>
                                                                            </div>
                                                                        </div>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row m-0 mt-2">
                                                        <div className="col-6 p-0">
                                                            <div className="elementor-element-play-overview p-2 m-1">
                                                                <div className="d-flex justify-content-between text-center">
                                                                    <div className="align-self-center">
                                                                        <div className="p-1 text-left">
                                                                            <img
                                                                                className="icon-aff"
                                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5e4ede40-9f30-4c50-5278-136b8e2e0900/public"
                                                                                alt=""
                                                                            />
                                                                            <div>
                                                                                <h3 className="m-0">
                                                                                    <b>{this.state.stats.totalSignups || 0} </b>
                                                                                </h3>
                                                                            </div>
                                                                            <small role="button">
                                                                                ຈຳນວນຄລິກລິ້ງທັງໝົດ
                                                                            </small>
                                                                        </div>
                                                                    </div>
                                                                    <div className="align-self-center text-right">
                                                                        <div>
                                                                            <div>
                                                                                <small className="font-play-text">
                                                                                    ຈາກເດືອນທີ່ແລ້ວ
                                                                                </small>
                                                                            </div>
                                                                            <span className="badge text-bg-dark">
                                                                                {this.state.stats.percentChange || 0} %
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-6 p-0">
                                                            <div className="elementor-element-play-overview p-2 m-1">
                                                                <div className="d-flex justify-content-between text-center">
                                                                    <div className="align-self-center">
                                                                        <div className="p-1 text-left">
                                                                            <img
                                                                                className="icon-aff"
                                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a7961b16-c14d-495f-3d2f-c7ea12ab2c00/public"
                                                                                alt=""
                                                                            />
                                                                            <div>
                                                                                <h3 className="m-0">
                                                                                    <b>{this.state.stats.totalSignups || 0}</b>
                                                                                </h3>
                                                                            </div>
                                                                            <small role="button">
                                                                                ຈຳນວນສະມາຊິກທັງໝົດ
                                                                            </small>
                                                                        </div>
                                                                    </div>
                                                                    <div className="align-self-center text-right">
                                                                        <div>
                                                                            <div>
                                                                                <small className="font-play-text">
                                                                                    ຈາກເດືອນທີ່ແລ້ວ
                                                                                </small>
                                                                            </div>
                                                                            <span className="badge text-bg-dark">
                                                                                {this.state.stats.percentChange || 0} %
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex justify-content-between pt-2 pb-2">
                                                        <div role="button" className="align-self-center">
                                                            <img
                                                                className="icon-profile-title-left"
                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/f8270235-43e5-4c38-247d-98b9ebfbe700/public"
                                                                alt=""
                                                            />
                                                            <small>
                                                                <b>&nbsp;ສະມາຊິກໃໝ່ມື້ນີ້</b>
                                                            </small>
                                                        </div>
                                                        <div className="align-self-center">     <b>{this.state.stats.todaySignups || 0}</b> ຄົນ</div>
                                                    </div>
                                                    <hr className="m-0 color-hr" />
                                                    <div className="d-flex justify-content-between pt-2 pb-2">
                                                        <div role="button" className="align-self-center" onClick={(e) => {
                                                            this.checktab(e, 2)
                                                        }}>
                                                            <img
                                                                className="icon-profile-title-left"
                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/f8270235-43e5-4c38-247d-98b9ebfbe700/public"
                                                                alt=""
                                                            />
                                                            <small>
                                                                <b>&nbsp;ປະຫວັດ</b>
                                                            </small>
                                                        </div>
                                                        <div className="align-self-center" onClick={(e) => {
                                                            this.checktab(e, 2)
                                                        }}>
                                                            <img
                                                                className="goto-financial"
                                                                role="button"
                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/ad650691-9c48-4cb9-6e44-36d5d1eaf700/public"
                                                                alt=""
                                                            />
                                                        </div>
                                                    </div>
                                                    <hr className="m-0 color-hr" />
                                                    <div className="d-flex justify-content-between pt-2 pb-2">
                                                        <div role="button" className="align-self-center" onClick={(e) => {
                                                            this.checktab(e, 4)
                                                        }}>
                                                            <img
                                                                className="icon-profile-title-left"
                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/f8270235-43e5-4c38-247d-98b9ebfbe700/public"
                                                                alt=""
                                                            />
                                                            <small>
                                                                <b>&nbsp;ວິທີການສ້າງເຄືອຂ່າຍ </b>
                                                            </small>
                                                        </div>
                                                        <div className="align-self-center" onClick={(e) => {
                                                            this.checktab(e, 4)
                                                        }}>
                                                            <img
                                                                className="goto-financial"
                                                                role="button"
                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/ad650691-9c48-4cb9-6e44-36d5d1eaf700/public"
                                                                alt=""
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                {/**/}
                                            </div>
                                            {/**/}
                                            {/**/}
                                            {/**/}
                                        </div>
                                    </div>
                                    <div className="mb-5 mt-2" style={{ display: this.state.tabselect == 2 ? "" : "none" }}>
                                        <div className="p-2 bg-profile-box-overview">
                                            {/**/}
                                            <div className="  ">
                                                <div className="box-number text-center">
                                                    <div>
                                                        <div className="bg-profile-box-overview p-2 mb-2">
                                                            <div className="d-flex justify-content-between row m-0 align-items-center">
                                                                <div className="col-12 col-md-12 p-0">
                                                                    <div className="d-flex justify-content-between elementor-element-play-overview text-center bg-profile-credit-bl p-2">
                                                                        <div className="align-self-center">
                                                                            <div className="p-1 text-left">
                                                                                <small>
                                                                                    <img
                                                                                        className="icon-aff"
                                                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/84f8435d-3a19-4e45-eb3c-57f582263300/public"
                                                                                        alt=""
                                                                                    />{" "}
                                                                                    ຍອດແອັກທີບທັງໝົດ
                                                                                </small>
                                                                                <div>
                                                                                    <label className="m-0 font-member-aff-all">
                                                                                        <b className="p-1">{this.state.stats.totalSignups || 0}</b>
                                                                                    </label>{" "}
                                                                                    ຄົນ
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="align-self-center text-right">
                                                                            <div>
                                                                                <span className="badge text-bg-dark">0.00%</span>
                                                                            </div>
                                                                            <div>
                                                                                <span className="font-play-text text_aff_affiliate">
                                                                                    ຈາກເດືອນທີ່ແລ້ວ
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-12">
                                                                <div className="d-flex justify-content-between scroll-title-history-aff align-items-center mb-1 mt-1">
                                                                    {timeRanges.map((range) => (
                                                                        <div key={range.key}>
                                                                            <a
                                                                                className={`btn btn-outline-secondary text_aff_affiliate_tab ${this.state.timeRange === range.key ? "text_aff_affiliate_tab_active" : ""
                                                                                    }`}
                                                                                role="button"
                                                                                onClick={() => this.handleTimeRangeChange(range.key, 1)}
                                                                            >
                                                                                {range.label}
                                                                            </a>
                                                                        </div>
                                                                    ))}
                                                                </div>

                                                                <div className="wg-content " style={{ display: (this.state.afficiatetoday.length === 0) ? "none" : "" }}>
                                                                    <table className="table table-borderless table-striped">
                                                                        <tbody>
                                                                            {this.state.afficiatetoday.map((listitem, i) => (
                                                                                <tr className="text-center cl-mod-1">
                                                                                    <td className="p-1-aff" style={{ width: '50px' }}><img className="icon-aff-member"
                                                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/57836a6a-99c5-4a6f-cad8-32de65521a00/public"
                                                                                        alt="" /></td>
                                                                                    <td className="text-left p-1-aff text_aff_affiliate"><b>{offset + i + 1}</b></td>
                                                                                    <td className="text-left p-1-aff text_aff_affiliate">{listitem.playerid}</td>
                                                                                </tr>
                                                                            ))}

                                                                        </tbody>


                                                                    </table>
                                                                    <div className="d-flex justify-content-center mt-3">
                                                                        <button
                                                                            className="btn btn-light"
                                                                            onClick={() => this.handlePageChange(this.state.currentPage - 1)}
                                                                            disabled={this.state.currentPage === 1}
                                                                        >
                                                                            <i className="fas fa-chevron-left"></i> {/* Icon ລູກສອນຊ້າຍ */}
                                                                        </button>
                                                                        <span className="mx-2">
                                                                            Page {this.state.currentPage} of {this.state.totalPages}
                                                                        </span>
                                                                        <button
                                                                            className="btn btn-light"
                                                                            onClick={() => this.handlePageChange(this.state.currentPage + 1)}
                                                                            disabled={this.state.currentPage === this.state.totalPages}
                                                                        >
                                                                            <i className="fas fa-chevron-right"></i> {/* Icon ລູກສອນຂວາ */}
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div className="row m-0">
                                                            <div className="col-12 col-md-6 p-1">
                                                                <div className="elementor-element-play-overview p-2">
                                                                    <div className="d-flex justify-content-between text-center">
                                                                        <div className="align-self-center">
                                                                            <div className="p-1 text-left">
                                                                                <img
                                                                                    className="icon-aff"
                                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/57836a6a-99c5-4a6f-cad8-32de65521a00/public"
                                                                                    alt=""
                                                                                />{" "}
                                                                                LV 1{" "}
                                                                                <div>
                                                                                    <b className="m-0 font-member-aff">0</b>
                                                                                    <small className="text_aff_affiliate">ຄົນ</small>
                                                                                </div>
                                                                                <small className="text_aff_affiliate">
                                                                                    ແນະນຳສະມາຊິກທັງໝົດ
                                                                                </small>
                                                                            </div>
                                                                        </div>
                                                                        <div className="align-self-center text-right">
                                                                            <div>
                                                                                <div>
                                                                                    <small className="font-play-text text_aff_affiliate">
                                                                                        ຈາກເດືອນທີ່ແລ້ວ
                                                                                    </small>
                                                                                </div>
                                                                                <span className="badge text-bg-dark">0.00%</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="bg-profile-box-overview p-2 mb-2 mt-2">
                                                            <div className="d-flex justify-content-between row m-0 align-items-center">
                                                                <div className="col-12 col-md-12 p-0">
                                                                    <div className="d-flex justify-content-between elementor-element-play-overview text-center bg-profile-credit-bl p-2">
                                                                        <div className="align-self-center">
                                                                            <div className="p-1 text-left">
                                                                                <small className="text_aff_affiliate">
                                                                                    ຍອດການຫຼິ້ນທຸກປະເພດ
                                                                                </small>
                                                                                <div>
                                                                                    <label className="m-0">
                                                                                        <b className="p-1">0 ຄົນ</b>
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <table className="table">
                                                                <tbody>
                                                                    <tr className="text-center cl-mod-1">
                                                                        <td className="p-1-aff" style={{ width: 50 }}>
                                                                            <img
                                                                                className="icon-aff-member"
                                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/57836a6a-99c5-4a6f-cad8-32de65521a00/public"
                                                                                alt=""
                                                                            />
                                                                        </td>
                                                                        <td className="text-left p-1-aff text_aff_affiliate">
                                                                            <b>ລຳດັບທີ່ 1</b>
                                                                        </td>
                                                                        <td className="text-left p-1-aff text_aff_affiliate">0</td>
                                                                        <td className="p-1-aff text_aff_affiliate">ຄົນ</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div className="d-flex justify-content-between pt-2 pb-2">
                                                            <div role="button" className="align-self-end">
                                                                <small>
                                                                    <b>&nbsp;ລາຍລະອຽດເຄືອຂ່າຍ</b>
                                                                </small>
                                                            </div>
                                                        </div>
                                                        <div className="bg-profile-box-overview p-2 mb-2">
                                                            <table className="table">
                                                                <thead className="table-dark-history">
                                                                    <tr className="bg-table-dark-history-title">
                                                                        <td className="credit-bl-text text_aff_affiliate">
                                                                            <small>ວັນທີ່</small>
                                                                        </td>
                                                                        <td className="credit-bl-text text_aff_affiliate">
                                                                            <small>ຍອດຖອນ</small>
                                                                        </td>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr className="bg-table-dark-history">
                                                                        <td colSpan={2} className="text-white-v1 text-center">
                                                                            <div>
                                                                                <div className="bg-profile-box-overview p-2 text-center   ">
                                                                                    <b>
                                                                                        <img
                                                                                            className="load-history"
                                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e4ac87bf-3687-4f37-c96e-6ad9e797bf00/public"
                                                                                            alt=""
                                                                                        />
                                                                                        <div className="not-history font-history-menu-text p-2">
                                                                                            <small>
                                                                                                <b>ບໍ່ພົບລາຍການ...</b>
                                                                                            </small>
                                                                                        </div>
                                                                                    </b>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/**/}
                                            {/**/}
                                        </div>
                                    </div>
                                    <div className="mb-5 mt-2" style={{ display: this.state.tabselect == 3 ? "" : "none" }}>
                                        <div className="p-2 bg-profile-box-overview">
                                            {/**/}
                                            {/**/}
                                            <div className="  ">
                                                <div className="align-self-center">
                                                    <div className="p-1 text-left">
                                                        <label>ສະຫຼຸບລາຍໄດ້ ທັງໝົດ</label>
                                                    </div>
                                                </div>
                                                <div className="bg-profile-box-overview p-2 mb-2">
                                                    <div className="d-flex justify-content-between row m-0 align-items-center">
                                                        <div className="col-12 col-md-12 p-0">
                                                            <div className="d-flex justify-content-between elementor-element-play-overview text-center bg-profile-credit-bl p-2">
                                                                <div className="align-self-center">
                                                                    <div className="p-1 text-left">
                                                                        <div>
                                                                            <small className="text_aff_affiliate">
                                                                                ລາຍໄດ້ຈາກເຄືອຂ່າຍ ທັງໝົດ
                                                                            </small>
                                                                            <h3 className="m-0">
                                                                                <b className="p-1">{this.state.reports && this.state.reports.lastMonth
                                                                                    ? this.state.reports.lastMonth.totalAmount
                                                                                    : 0}</b>
                                                                            </h3>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="align-self-center text-right">
                                                                    <div>
                                                                        <span className="badge text-bg-dark">{this.state.reports.percentageChange}%</span>
                                                                    </div>
                                                                    <div>
                                                                        <span className="font-play-text text_aff_affiliate">
                                                                            ຈາກເດືອນທີ່ແລ້ວ
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="pt-2">
                                                        <div className="row m-0">
                                                            <div className="col-12 col-md-12 p-1">
                                                                <div className="d-flex justify-content-between financial-button">
                                                                    <div
                                                                        role="button"
                                                                        className="align-self-center p-1 credit-bl-text"
                                                                    >
                                                                        <div role="button" className="financial-button-r">
                                                                            <div className="d-flex justify-content-start">
                                                                                <div className="align-self-center">
                                                                                    <img
                                                                                        className="logo-profile-user-w p-1"
                                                                                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/48a22d9a-8abe-477f-0f40-57204ce17700/public"
                                                                                        alt=""
                                                                                    />
                                                                                </div>
                                                                                <div className="align-self-center">
                                                                                    <div className="username-profile">
                                                                                        <small>ລາຍໄດ້ທີ່ຖອນໄດ້</small>
                                                                                    </div>
                                                                                    <div className="username-profile">
                                                                                        <small>
                                                                                            <b className="font-aff-wid">0.00</b>
                                                                                        </small>
                                                                                        <a
                                                                                            role="button"
                                                                                            className="text-white-v1-credit-balance p-1"
                                                                                            id="icon-refresh-credit"
                                                                                        >
                                                                                            <span>
                                                                                                <b>
                                                                                                    <svg
                                                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                                                        width={18}
                                                                                                        height={18}
                                                                                                        fill="currentColor"
                                                                                                        className="text-white-v1 bi bi-arrow-clockwise"
                                                                                                        viewBox="0 0 16 16"
                                                                                                    >
                                                                                                        <path
                                                                                                            fillRule="evenodd"
                                                                                                            d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
                                                                                                        />
                                                                                                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                                                                                                    </svg>
                                                                                                </b>
                                                                                            </span>
                                                                                        </a>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="bg-profile-box-overview p-2 mb-2">
                                                    <div className="d-flex justify-content-between row m-0 align-items-center">
                                                        <div className="col-12 col-md-12 p-0">
                                                            <div className="d-flex justify-content-between elementor-element-play-overview text-center bg-profile-credit-bl">
                                                                <div className="align-self-center">
                                                                    <div className="p-1 text-left">
                                                                        <div>
                                                                            <img
                                                                                className="icon-aff-member"
                                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/db83e83e-f021-468d-995c-c10ebf09fb00/public"
                                                                                alt=""
                                                                            />
                                                                            <small className="text_aff_affiliate">
                                                                                ຄົ້ນຫາທີ່ມາລາຍໄດ້
                                                                            </small>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row text-center m-0">
                                                        <div className="col-12 col-md-6 p-1">
                                                            <select
                                                                className="form-control option-search-aff"
                                                                style={{ textAlign: "center" }}
                                                            >
                                                                <option value="all">ທຸກເລເວວ</option>
                                                                <option value="lv1">level 1</option>
                                                                <option value="lv2">level 2</option>
                                                                <option value="lv3">level 3</option>
                                                                <option value="lv5">level 5</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-12 col-md-6 p-1">
                                                            <select
                                                                className="form-control option-search-aff"
                                                                style={{ textAlign: "center" }}
                                                            >
                                                                <option value="all">ທຸກປະເພດ</option>
                                                                <option value="slot">ສລັອດ-slot</option>
                                                                <option value="casino">ຄາສິໂນ-casino</option>
                                                                <option value="winloss">ຍອດເສຍ-winloss</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-12 col-md-12 p-1 text-left">
                                                            <div className="input-group">
                                                                <input
                                                                    type="text"
                                                                    className="form-control bg-income-summary text-center-s-date font-play-text"
                                                                    placeholder="ມື້ນີ້ — ມື້ນີ້"
                                                                    aria-label="ມື້ນີ້ — ມື້ນີ້"
                                                                    disabled=""
                                                                    aria-describedby="basic-addon2"
                                                                />
                                                                <span
                                                                    role="button"
                                                                    className="input-group-text"
                                                                    id="basic-addon2"
                                                                >
                                                                    {/* <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width={16}
                                                                                height={16}
                                                                                fill="currentColor"
                                                                                className="bi bi-calendar"
                                                                                viewBox="0 0 16 16"
                                                                            >
                                                                                <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
                                                                            </svg> */}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="col-12">
                                                            <div className="row text-center">
                                                                <div className="col-12 col-md-6 p-1">
                                                                    <div role="button" className="affiliate-aff-search p-2">
                                                                        <label className="font-play-text">ລ້າງຄ່າ</label>
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-md-6 p-1">
                                                                    <div role="button" className="affiliate-aff-search-submit p-2">
                                                                        <label>ຄົ້ນຫາ</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="credit-bl-text pb-2">
                                                    <span>
                                                        <small>ທ່ານກຳລັງເບິ່ງຊ່ວງເວລາ &nbsp; </small>
                                                    </span>
                                                </div>
                                                <div className="bg-profile-box-overview p-2 mb-2">
                                                    <div className="d-flex justify-content-between pb-2">
                                                        <div className="d-flex justify-content-start align-items-center">
                                                            <div className="p-2">
                                                                <img
                                                                    className="icon-aff-member"
                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/57836a6a-99c5-4a6f-cad8-32de65521a00/public"
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div>
                                                                <div>
                                                                    <h5 className="credit-bl-text">
                                                                        <b>ລະດັບທີ່ 1</b>
                                                                    </h5>
                                                                </div>
                                                                <div>
                                                                    <small className="text_aff_affiliate">
                                                                        ລາຍລະອຽດການເຮັດລາຍໄດ້
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <table className="table mb-0">
                                                        <thead className="table-dark-history">
                                                            <tr className="bg-table-dark-history-title">
                                                                <td className="credit-bl-text text_aff_affiliate text-center">
                                                                    <small>ປະເພດ</small>
                                                                </td>
                                                                <td className="credit-bl-text text_aff_affiliate text-center">
                                                                    <small>ຍອດແທງ</small>
                                                                </td>
                                                                <td className="credit-bl-text text_aff_affiliate text-center">
                                                                    <small>ລາຍໄດ້</small>
                                                                </td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr className="bg-table-dark-history">
                                                                <td colSpan={3} className="text-white-v1 text-center">
                                                                    <div>
                                                                        <div className="bg-profile-box-overview p-2 text-center   ">
                                                                            <b>
                                                                                <img
                                                                                    className="load-history"
                                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e4ac87bf-3687-4f37-c96e-6ad9e797bf00/public"
                                                                                    alt=""
                                                                                />
                                                                                <div className="not-history font-history-menu-text p-2">
                                                                                    <small>
                                                                                        <b>ບໍ່ພົບລາຍການ...</b>
                                                                                    </small>
                                                                                </div>
                                                                            </b>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                {/* <div className="bg-profile-box-overview p-2 mb-2">
                                                            <div className="d-flex justify-content-between pb-2">
                                                                <div className="d-flex justify-content-start align-items-center">
                                                                    <div className="p-2">
                                                                        <img
                                                                            className="icon-aff-member"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/57836a6a-99c5-4a6f-cad8-32de65521a00/public"
                                                                            alt=""
                                                                        />
                                                                    </div>
                                                                    <div>
                                                                        <div>
                                                                            <h5 className="credit-bl-text">
                                                                                <b>ລະດັບທີ່ 2</b>
                                                                            </h5>
                                                                        </div>
                                                                        <div>
                                                                            <small className="text_aff_affiliate">
                                                                                ລາຍລະອຽດການເຮັດລາຍໄດ້
                                                                            </small>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <table className="table mb-0">
                                                                <thead className="table-dark-history">
                                                                    <tr className="bg-table-dark-history-title">
                                                                        <td className="credit-bl-text text_aff_affiliate text-center">
                                                                            <small>ປະເພດ</small>
                                                                        </td>
                                                                        <td className="credit-bl-text text_aff_affiliate text-center">
                                                                            <small>ຍອດແທງ</small>
                                                                        </td>
                                                                        <td className="credit-bl-text text_aff_affiliate text-center">
                                                                            <small>ລາຍໄດ້</small>
                                                                        </td>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr className="bg-table-dark-history">
                                                                        <td colSpan={3} className="text-white-v1 text-center">
                                                                            <div>
                                                                                <div className="bg-profile-box-overview p-2 text-center   ">
                                                                                    <b>
                                                                                        <img
                                                                                            className="load-history"
                                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e4ac87bf-3687-4f37-c96e-6ad9e797bf00/public"
                                                                                            alt=""
                                                                                        />
                                                                                        <div className="not-history font-history-menu-text p-2">
                                                                                            <small>
                                                                                                <b>ບໍ່ພົບລາຍການ...</b>
                                                                                            </small>
                                                                                        </div>
                                                                                    </b>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div className="bg-profile-box-overview p-2 mb-2">
                                                            <div className="d-flex justify-content-between pb-2">
                                                                <div className="d-flex justify-content-start align-items-center">
                                                                    <div className="p-2">
                                                                        <img
                                                                            className="icon-aff-member"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/57836a6a-99c5-4a6f-cad8-32de65521a00/public"
                                                                            alt=""
                                                                        />
                                                                    </div>
                                                                    <div>
                                                                        <div>
                                                                            <h5 className="credit-bl-text">
                                                                                <b>ລະດັບທີ່ 3</b>
                                                                            </h5>
                                                                        </div>
                                                                        <div>
                                                                            <small className="text_aff_affiliate">
                                                                                ລາຍລະອຽດການເຮັດລາຍໄດ້
                                                                            </small>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <table className="table mb-0">
                                                                <thead className="table-dark-history">
                                                                    <tr className="bg-table-dark-history-title">
                                                                        <td className="credit-bl-text text_aff_affiliate text-center">
                                                                            <small>ປະເພດ</small>
                                                                        </td>
                                                                        <td className="credit-bl-text text_aff_affiliate text-center">
                                                                            <small>ຍອດແທງ</small>
                                                                        </td>
                                                                        <td className="credit-bl-text text_aff_affiliate text-center">
                                                                            <small>ລາຍໄດ້</small>
                                                                        </td>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr className="bg-table-dark-history">
                                                                        <td colSpan={3} className="text-white-v1 text-center">
                                                                            <div>
                                                                                <div className="bg-profile-box-overview p-2 text-center   ">
                                                                                    <b>
                                                                                        <img
                                                                                            className="load-history"
                                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e4ac87bf-3687-4f37-c96e-6ad9e797bf00/public"
                                                                                            alt=""
                                                                                        />
                                                                                        <div className="not-history font-history-menu-text p-2">
                                                                                            <small>
                                                                                                <b>ບໍ່ພົບລາຍການ...</b>
                                                                                            </small>
                                                                                        </div>
                                                                                    </b>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div className="bg-profile-box-overview p-2 mb-2">
                                                            <div className="d-flex justify-content-between pb-2">
                                                                <div className="d-flex justify-content-start align-items-center">
                                                                    <div className="p-2">
                                                                        <img
                                                                            className="icon-aff-member"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/57836a6a-99c5-4a6f-cad8-32de65521a00/public"
                                                                            alt=""
                                                                        />
                                                                    </div>
                                                                    <div>
                                                                        <div>
                                                                            <h5 className="credit-bl-text">
                                                                                <b>ລະດັບທີ່ 4</b>
                                                                            </h5>
                                                                        </div>
                                                                        <div>
                                                                            <small className="text_aff_affiliate">
                                                                                ລາຍລະອຽດການເຮັດລາຍໄດ້
                                                                            </small>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <table className="table mb-0">
                                                                <thead className="table-dark-history">
                                                                    <tr className="bg-table-dark-history-title">
                                                                        <td className="credit-bl-text text_aff_affiliate text-center">
                                                                            <small>ປະເພດ</small>
                                                                        </td>
                                                                        <td className="credit-bl-text text_aff_affiliate text-center">
                                                                            <small>ຍອດແທງ</small>
                                                                        </td>
                                                                        <td className="credit-bl-text text_aff_affiliate text-center">
                                                                            <small>ລາຍໄດ້</small>
                                                                        </td>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr className="bg-table-dark-history">
                                                                        <td colSpan={3} className="text-white-v1 text-center">
                                                                            <div>
                                                                                <div className="bg-profile-box-overview p-2 text-center   ">
                                                                                    <b>
                                                                                        <img
                                                                                            className="load-history"
                                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e4ac87bf-3687-4f37-c96e-6ad9e797bf00/public"
                                                                                            alt=""
                                                                                        />
                                                                                        <div className="not-history font-history-menu-text p-2">
                                                                                            <small>
                                                                                                <b>ບໍ່ພົບລາຍການ...</b>
                                                                                            </small>
                                                                                        </div>
                                                                                    </b>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div className="bg-profile-box-overview p-2 mb-2">
                                                            <div className="d-flex justify-content-between pb-2">
                                                                <div className="d-flex justify-content-start align-items-center">
                                                                    <div className="p-2">
                                                                        <img
                                                                            className="icon-aff-member"
                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/57836a6a-99c5-4a6f-cad8-32de65521a00/public"
                                                                            alt=""
                                                                        />
                                                                    </div>
                                                                    <div>
                                                                        <div>
                                                                            <h5 className="credit-bl-text">
                                                                                <b>ລະດັບທີ່ 5</b>
                                                                            </h5>
                                                                        </div>
                                                                        <div>
                                                                            <small className="text_aff_affiliate">
                                                                                ລາຍລະອຽດການເຮັດລາຍໄດ້
                                                                            </small>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <table className="table mb-0">
                                                                <thead className="table-dark-history">
                                                                    <tr className="bg-table-dark-history-title">
                                                                        <td className="credit-bl-text text_aff_affiliate text-center">
                                                                            <small>ປະເພດ</small>
                                                                        </td>
                                                                        <td className="credit-bl-text text_aff_affiliate text-center">
                                                                            <small>ຍອດແທງ</small>
                                                                        </td>
                                                                        <td className="credit-bl-text text_aff_affiliate text-center">
                                                                            <small>ລາຍໄດ້</small>
                                                                        </td>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr className="bg-table-dark-history">
                                                                        <td colSpan={3} className="text-white-v1 text-center">
                                                                            <div>
                                                                                <div className="bg-profile-box-overview p-2 text-center   ">
                                                                                    <b>
                                                                                        <img
                                                                                            className="load-history"
                                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/e4ac87bf-3687-4f37-c96e-6ad9e797bf00/public"
                                                                                            alt=""
                                                                                        />
                                                                                        <div className="not-history font-history-menu-text p-2">
                                                                                            <small>
                                                                                                <b>ບໍ່ພົບລາຍການ...</b>
                                                                                            </small>
                                                                                        </div>
                                                                                    </b>
                                                                                </div>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div> */}
                                            </div>
                                            {/**/}
                                        </div>
                                    </div>
                                    <div className="mb-5 mt-2" style={{ display: this.state.tabselect == 4 ? "" : "none" }}>
                                        <div className="p-2 bg-profile-box-overview">
                                            {/**/}
                                            {/**/}
                                            {/**/}
                                            <div className="   text-center">
                                                <div className="bg-profile-box p-2">
                                                    <div>
                                                        <div className="p-2 align-self-center">
                                                            <div className="username-profile">
                                                                <b>ລວຍງ່າຍໆ ກັບ ພວກເຮົາ</b>
                                                            </div>
                                                            <div className="username-profile">
                                                                <b>ພຽງແບ່ງປັນລິ້ງກໍສ້າງລາຍໄດ້</b>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="d-flex justify-content-between row m-0 align-items-center">
                                                        <div className="col-12 col-md-12 p-0">
                                                            <section className="carousel" dir="ltr" aria-label="Gallery">

                                                            </section>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        );
    }
}
export default App;
